export default __webpack_public_path__ + "static/DiscordCanary_9EdQ4hkP3l-391abb6f31de2f66db7ab159a1daa9dc.png";